(ns common.widgets.card
  (:require ["@mui/material/Avatar$default" :as Avatar]
            ["@mui/material/Card$default" :as Card]
            ["@mui/material/CardActionArea$default" :as CardActionArea]
            ["@mui/material/CardContent$default" :as CardContent]
            ["@mui/material/CardHeader$default" :as CardHeader]
            ["@mui/material/Radio$default" :as Radio]
            ["@mui/material/Stack$default" :as Stack]
            [common.util :as util]
            [goog.object :as gobject]
            [uix.core :as uix :refer [$ defui]]))

(defui selectable
  [{:keys [onChange value id disabled title icon radio? radio-props sx children]
    :or {radio? true}}]
  ($ Card
     {:variant "outlined"
      :sx #js {:border 0
               :overflow "visible"}}
     ($ CardActionArea
        {:onClick #(onChange id)
         :disabled disabled
         :data-active (when (= value id) "")
         :sx (fn [^js theme]
               (util/spread-obj
                #js {:fontFamily (.. theme -typography -fontFamily)
                     :px 3
                     :py 2.5
                     :width "unset"
                     :borderWidth "1px"
                     :borderStyle "solid"
                     :borderColor "grey.50"
                     "&.Mui-disabled" #js {:color "grey.50"}
                     "&:hover" #js {:borderColor "grey.30"}
                     "&[data-active]" #js {:borderColor "primary.main"
                                           :borderWidth "2px"
                                           :m "-1px"}
                     "&[data-active]:hover" #js {:borderColor "primary.400"}
                     "&[data-active].Mui-disabled" #js {:color "initial"
                                                        :borderColor "primary.light"}}
                sx))}
        ($ CardHeader
           {:avatar (when icon
                      ($ Avatar
                         {:sx (fn [^js theme]
                                (util/spread-obj
                                 #js {:width 32
                                      :height 32
                                      :backgroundColor "grey.80"
                                      "& svg *" #js {:fill (gobject/get (.. theme -palette -grey) "50")}}
                                 (when (= value id)
                                   #js {:backgroundColor "primary.100"
                                        "& svg *" #js {:fill (.. theme -palette -primary -main)}})))}
                         icon))
            :title title
            :action (when radio?
                      ($ Radio
                         (util/spread-props
                          radio-props
                          {:checked (= value id)
                           :onChange #(onChange id)
                           :disabled disabled})))
            :slotProps #js {:title #js {:variant "h3"}}
            :sx #js {:p 0}})
        ($ CardContent
           {:component Stack
            :sx #js {:fontSize "md"
                     :p 0
                     :mt 0.75}}
           children))))
